export const WALLET_TOKEN_KEY = 'walletconnect';
